import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import type { PricingSaasResponse } from '../types';

interface PageSelectorProps {
  pages: PricingSaasResponse[];
  currentIndex: number;
  onChange: (index: number) => void;
}

export const PageSelector = ({ pages, currentIndex, onChange }: PageSelectorProps) => {
  if (pages.length <= 1) {
    return null;
  }

  return (
    <div className="flex items-center gap-2">
      <span className="text-sm text-gray-600">Pricing Page:</span>
      <Select
        value={currentIndex.toString()}
        onValueChange={(value) => onChange(parseInt(value, 10))}
      >
        <SelectTrigger className="w-[180px]">
          <SelectValue placeholder="Select a page" />
        </SelectTrigger>
        <SelectContent>
          {pages.map((page, index) => (
            <SelectItem key={index} value={index.toString()}>
              {page.version ? `${page.version}` : `Page ${index + 1}`}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
